import { render, staticRenderFns } from "./MyComments.vue?vue&type=template&id=09677dce"
import script from "./MyComments.vue?vue&type=script&lang=js"
export * from "./MyComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports